// extracted by mini-css-extract-plugin
export default {"page-cashier":"index_page-cashier__2yZx4"};